export function joinPropertyWithCommas(arr, property) {
    // Extract the values of the specified property using map
    const values = arr.map(obj => obj[property]);
    // Join the values with commas using join
    return values.join(', ');
}